
function ErrorPage() {
    return (
      <div>  
        Erro
      </div>
    );
  }
  
  export default ErrorPage